import React, { useCallback, useEffect, useState, useRef } from 'react';
import Button from 'components/atoms/Button';
import { TransactionsData } from '../../../mockData/TransactionsData';
import printerIcon from '../../../assets/svg/printer.svg';
import copyIcon from '../../../assets/svg/copy.svg';
import mastercard from '../../../assets/svg/mastercard.svg';
import nigeriaIcon from '../../../assets/svg/nigeria_flag.svg';
import seerbitMonoIcon from '../../../assets/icons/seerbit_monochrome.png';
import seerbitDarkBg from '../../../assets/images/seerbit_dark_bg.png';
import PageTitleHeader from 'components/molecules/PageTitleHeader';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import ColorTag from 'components/atoms/ColorTag';
import CopyText from 'components/atoms/CopyText';
import { printContent, printStyled } from '../../../components/atoms/PrintFunction';
import { handleDownload } from '../../../components/atoms/DownloadFunction';
import { handleException } from 'utils';
import axios from 'services/axios';
import { BASE_URL } from 'services/http';
import { connect } from 'react-redux';
import Alert from 'components/atoms/Alert';
import ReceiptOutline from '../../../assets/svg/receipt-icon.svg';
import { store } from '../../../redux/store';
import Spinner from 'components/atoms/Spinner';
import BackButton from 'components/atoms/BackButton';
import { act } from 'react-dom/test-utils';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import TextArea from 'components/atoms/TextAreaInput/TextArea';

const state = store.getState()

const TransactionOverview = (props) => {
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [data, setData] = useState<any>({});
    const elementRef = useRef<HTMLDivElement | null>(null);

    const transactionRef = useParams()

    const url = `transaction/reference/${transactionRef.id}`

    const fetchTrasactionData = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${BASE_URL + url}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${props.bearerToken}`,
                    "Public-Key": `${props.publicKey}`
                }
            })
            if (res.data.code === 'error') {
                setLoading(false)
                Alert('error', res.data.message)
            } else {
                setLoading(false)
                setData(res.data.data)
            }
            return res;
        } catch (error) {
            setLoading(false)
            setErrorState(true)
            handleException(error)
        }
    }

    console.log("Data:", data);


    useEffect(() => {
        fetchTrasactionData()
    }, [])

    const fileName = `Transaction_receipt_${transactionRef.id}`;

    const handleDownloadPdf = useCallback(async () => {
        if (!elementRef.current) return;
        const canvas = await html2canvas(elementRef.current);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${fileName}.pdf`);
    }, [fileName]);

    const multipleBtnData = [
        { btnText: "Print Receipt", btnStyle: "bg-SecondaryAccent2 flex-row-reverse px-4 py-2 font-semibold desktop:text-sm mobile:text-xs text-DarkBg3 truncate flex-shrink-0", btnImg: printerIcon, btnImgStyle: "w-4 h-4", onClick: () => printContent(elementRef.current) },
        { btnText: "Download Receipt", btnStyle: "bg-DarkBg3 px-10 py-2 font-semibold desktop:text-sm mobile:text-xs text-white flex-shrink-0", btnImg: "", btnImgStyle: "", onClick: handleDownloadPdf }
    ]

    return (
        <div className='relative'>
            <BackButton />
            {loading
                ? <div className={`absolute z-20 flex items-center py-10 justify-center w-full h-[90vh]`}>
                    <Spinner
                        text="Fetching data..."
                    />
                </div>

                : <div className='py-5 flex flex-col gap-5 tablet:gap-8 relative overflow-hidden'>
                    <PageTitleHeader
                        title="Transaction Overview"
                        btn_num={2}
                        btnData={multipleBtnData}
                    />

                    <div className='border rounded-md'>
                        <div className='border-b mobile:border-none mb-12'>
                            <div className='flex desktop:flex-row flex-col justify-between items-start desktop:p-10 p-4 gap-20'>
                                <div className='w-full max-w-[100%]'>
                                    <div className='flex gap-5 items-center'>
                                        <span className='font-[500] text-[30px] mobile:text-xl leading-7 text-DarkBg3'>{data.transactionCurrency + " " + (Intl.NumberFormat().format(data.transactionAmount))}</span>
                                        <span className={`${data?.message === 'Success' || data?.message === "Successful" ? 'bg-Green_Accent8 text-Success2' : 'bg-DangerAccent5 text-Danger4'} px-[10px] py-[5px] rounded-md flex justify-center items-center gap-2`}>
                                            <span className={`w-[6px] h-[6px] rounded-full ${data?.message === 'Success' || data?.message === "Successful" ? 'bg-Success2' : 'bg-Danger4'}`}></span>
                                            {data?.message === 'Success' || data?.message === "Successful" ? 'Success' : "Failed"}
                                        </span>
                                        {/* <span className={`${data.transactionLeg === 'CREDIT' ? 'bg-Green_Accent8 text-Success2' : 'bg-DangerAccent5 text-Danger4'} rounded-d px-2 py-1 text-xs leading-[15.6px] font-semibold`}>{data.transactionLeg}</span> */}
                                        {/* <span className={`${data.message === "Success" ? 'bg-Green_Accent8 text-Success2' : 'bg-DangerAccent5 text-Danger4'} rounded-d px-2 py-1 flex justify-center items-center gap-2`}>
                                            <span className={`w-[6px] h-[6px] rounded-full ${data.message === "Success" ? 'bg-Success2' : 'bg-Danger4'}`}></span>
                                            <span className='text-xs leading-[15.6px] font-semibold'>
                                                {data.message === "Success" ? 'Success' : 'Failed'}
                                            </span>
                                        </span> */}
                                    </div>

                                    <div className='mb-12 mt-8 flex flex-col gap-3'>
                                        <span className='text-[15px] font-normal leading-7 text-DarkBg3'>{moment(data.createdAt).format("MMM DD, YYYY - LTS")}</span>
                                    </div>

                                    <CopyText
                                        text={data.reference}
                                        displayedText={data.reference?.length > 30 ? data.reference?.slice(0, 30) + "..." : data.reference}
                                        style='font-normal text-sm text-DarkBg'
                                        textArea='rounded-md p-2 bg-SecondaryAccent5'
                                    />
                                </div>
                                
                                <div className='flex flex-col w-full max-w-[100%]'>
                                    <span className='font-bold text-lg leading-[21.6px] pb-8 mb-5 border-b'>Sender Information</span>
                                    <div className='flex flex-col gap-5'>
                                        <span className='flex gap-5 justify-between items-center'>
                                            <p className='text-sm font-normal leading-[120%] '>Sender Name</p>
                                            <p className='font-[500] text-DarkBg8 text-sm'>{data.sender}</p>
                                        </span>
                                        <span className='flex gap-5 justify-between items-center'>
                                            <p className='text-sm font-normal leading-[120%] '>Pocket ID</p>
                                            <p className='font-[500] text-DarkBg8 text-sm'>{data.pocketId}</p>
                                        </span>
                                        <span className='flex gap-5 justify-between items-center'>
                                            <p className='text-sm font-normal leading-[120%] '>Email</p>
                                            <p className='font-[500] text-DarkBg8 text-sm'>{data.createdBy}</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='flex desktop:flex-row flex-col justify-between items-start desktop:p-10 p-4 mobile:gap-20 mb-12 gap-20'>
                            <div className='flex flex-col w-full '>
                                <span className='font-bold text-lg leading-[21.6px] pb-8 mb-5 border-b'>Transaction Details</span>
                                <div className='flex flex-col gap-5'>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Transaction ID</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.transactionId}</p>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Transaction Type</p>
                                        <span className={`${data.transactionLeg === 'CREDIT' ? 'bg-Green_Accent8 text-Success2' : 'bg-DangerAccent5 text-Danger4'} rounded-d px-2 py-1 flex justify-center items-center gap-2`}>{data.transactionLeg}</span>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Data and Time</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{moment(data.createdAt).format("MMM DD, YYYY - LTS")}</p>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Payment Channel</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.transactionType}</p>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Narration</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.description}</p>
                                    </span>
                                </div>
                            </div>

                            <div className='flex flex-col w-full  '>
                                <span className='font-bold text-lg leading-[21.6px] pb-8 mb-5 border-b'>Receiver Information</span>
                                <div className='flex flex-col gap-5'>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Receiver Name</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.receiverName}</p>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Account Number</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.receiverAccountNumber}</p>
                                    </span>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Bank Name</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.receiverBankName ?? data.receiverBankCode}</p>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='flex desktop:flex-row flex-col justify-start items-start desktop:p-10 p-4 mobile:gap-20'>
                            <div className='flex flex-col w-full max-w-[50%]'>
                                <span className='font-bold text-lg leading-[21.6px] pb-8 mb-5 border-b'>Breakdown of Amounts</span>
                                <div className='flex flex-col gap-5'>
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Transfer Amount</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.transactionCurrency + " " + (Intl.NumberFormat().format(data.transactionAmount))}</p>
                                    </span>
                                    {/* <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Fees/Charges:</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.transactionCurrency + " " + (Intl.NumberFormat().format(data.transactionAmount))}</p>
                                    </span> */}
                                    <span className='flex gap-5 justify-between items-center'>
                                        <p className='text-sm font-normal leading-[120%] '>Total Amount Deducted</p>
                                        <p className='font-[500] text-DarkBg8 text-sm'>{data.transactionCurrency + " " + (Intl.NumberFormat().format(data.transactionAmount))}</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="opacity-0 absolute top-full -z-50 w-full max-w-[595px] h-fit bg-white">
                        <ReceiptComponent
                            data={data}
                            elementRef={elementRef}
                            currency={data.transactionCurrency}
                            pocketTier={props.pocketTier}
                            pocketBal={props.pocketBal}
                            active={active}
                        />
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    pocketTier: state.app.pocketTier,
    pocketBal: state.app.pocketBal,
    bearerToken: state.auth.token,
    publicKey: state.auth.public_key,
})

export default connect(mapStateToProps)(TransactionOverview);







const ReceiptComponent = ({ data, elementRef, currency, pocketTier, pocketBal, active }) => {
    const receiptData = [
        {
            label: "Transaction Date & Time",
            info: [moment(data.createdAt).format("DD MMMM, YYYY, LT")]
        },
        {
            label: "Sender",
            info: [data.sender]
        },
        {
            label: "Receiver",
            info: [
                data.receiverName,
                data.receiverAccountNumber,
                data.receiverBankName ?? data.receiverBankCode,
            ]
        },
        {
            label: "Transaction Reference",
            info: [data.reference]
        },
        {
            label: "Transaction Status",
            info: [data.status === '00' ? 'Successful' : 'Failed']
        },
        {
            label: "Narration",
            info: [data.description]
        }
    ]

    return (
        <div ref={elementRef} className='flex flex-col w-full shadow-[0_8px_30px_rgb(0,0,0,0.12)]'>
            <div className='bg-black px-10 py-4 relative z-[12]'>
                <span className='absolute left-0 top-0 w-full h-full z-[12]'>
                    <img src={seerbitDarkBg} alt='seerbitDarkBg' className='w-full h-full' />
                </span>
                <span className='relative left-0 top-0 w-full h-full z-[15] flex justify-between items-center'>
                    <span className='text-white max-w-[150px] font-bold text-[28px]'>
                        <h3>Transaction Receipt</h3>
                    </span>
                    <img src={seerbitMonoIcon} alt="seerbitIcon" className='w-[66.66px] h-[66.66px]' />
                </span>
            </div>
            <div className='px-[76px] py-10 pb-24 flex flex-col gap-8'>
                <div className='bg-GrayCustom14 w-full rounded-xl py-7 flex flex-col justify-center items-center'>
                    <p className='text-xs font-normal text-DarkBg11'>Transaction Amount</p>
                    <p className='font-bold text-[50px] leading-5 text-DarkBg3 my-4'>
                        {currency + Number(data.transactionAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </p>
                    <p className='text-xs font-normal text-DarkBg11'>
                        {moment(data.createdAt).format("DD MMMM, YYYY, LT")}
                    </p>
                </div>
                <div className='flex flex-col gap-3 w-full mb-5'>
                    {receiptData.map((item, i) => (
                        <div className='border-b flex justify-between items-start'>
                            <span className='pl-4 py-2 w-2/5'>
                                <p className='font-semibold text-sm'>{item.label}</p>
                            </span>
                            <span className='pl-4 py-2 w-3/5 flex flex-col gap-3'>
                                {item.info.map((subItem, i) => (
                                    <p className='font-400 text-sm'>{subItem}</p>
                                ))}
                            </span>
                        </div>
                    ))}
                </div>

                <p className='text-xs font-normal leading-4 text-DarkBg10 text-center'>
                    For further complaints regarding this transaction, contact our support team at <span className='text-Accent_blue'>support@seerbit.com</span> or WhatsApp us at <span className='text-Accent_blue'>+2349062009331</span>.
                </p>
            </div>
        </div>
    )
}